import * as tslib_1 from "tslib";
/**
 * Copyright 2012-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material';
import { map } from 'rxjs/operators/map';
import { filter } from 'rxjs/operators/filter';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { DeleteDialogComponent } from './dialog-delete/delete-dialog.componet';
import { ExtRestConfig } from '../../services/rest/models';
var RestService = /** @class */ (function () {
    function RestService(config, http, dialog) {
        this.config = config;
        this.http = http;
        this.dialog = dialog;
    }
    /**
     * Clear invalied url from server.
     * Ex: http://localhost:8080/api/users{?page,size,sort}
     *
     * @param url invalid url
     */
    RestService.prototype.clearUrl = function (url) {
        var paraStart = url.indexOf('{?');
        if (paraStart > 0) {
            url = url.substring(0, paraStart);
        }
        return url;
    }; //  clearUrl()
    /**
     * Get Id from a url with tailing id
     * @param url
     */
    RestService.prototype.getId = function (url) {
        return url.substring(url.lastIndexOf('/') + 1);
    }; // getId()
    RestService.prototype.get = function (url, httpOptions) {
        return this.http.get(this.config.basePath + url, httpOptions);
    }; // get()
    RestService.prototype.post = function (url, object, httpOptions) {
        return this.http.post(this.config.basePath + url, object, httpOptions);
    }; // get()
    /**
     * Get All the data elements and without Paging Information
     * @param modelName
     * @param httpOptions
     */
    RestService.prototype.findAll = function (modelName, httpOptions) {
        return this.http
            .get(this.config.basePath + '/' + modelName, httpOptions)
            .pipe(map(function (res) { return res._embedded[modelName]; }));
    }; // findAll
    RestService.prototype.findAllByProperty = function (url, propertyName, httpOptions) {
        return this.http.get(url, httpOptions).pipe(map(function (res) { return res._embedded[propertyName]; }));
    };
    RestService.prototype.findOne = function (item) {
        return this.http.get(item._links.self.href);
    };
    /**
     * Search for all the result
     * @param url
     * @param httpOptions
     */
    RestService.prototype.search = function (url, httpOptions) {
        return this.http.get(url, httpOptions);
    };
    /** Save thte Object.*/
    RestService.prototype.save = function (item) {
        if (item._links) {
            return this.patch(item);
        }
        else {
            return this.http.post(item._links.self.href, item);
        }
    }; // save()
    /** Patch the given object.*/
    RestService.prototype.patch = function (item) {
        return this.http.patch(item._links.self.href, item);
    }; // patch
    /** Put the given object. */
    RestService.prototype.put = function (item) {
        return this.http.put(item._links.self.href, item);
    };
    /** Delete all */
    RestService.prototype.deleteAllWithConfirm = function (urls) {
        var _this = this;
        return this.showDeleteConfimDialog().pipe(filter(function (result) { return result; }), mergeMap(function () {
            var requests = [];
            urls.forEach(function (url) { return requests.push(_this.http.delete(url)); });
            return forkJoin(requests);
        }));
    }; // deleteAllWithConfirm
    RestService.prototype.deleteWithConfirm = function (url) {
        return this.deleteAllWithConfirm([url]).pipe(map(function (d) { return d[0]; }));
    }; //  deleteWithConfirm()
    RestService.prototype.showDeleteConfimDialog = function () {
        var dialogRef = this.dialog.open(DeleteDialogComponent);
        return dialogRef.afterClosed();
    };
    RestService = tslib_1.__decorate([
        Injectable(),
        tslib_1.__metadata("design:paramtypes", [ExtRestConfig,
            HttpClient,
            MatDialog])
    ], RestService);
    return RestService;
}()); // class
export { RestService };
//# sourceMappingURL=rest.service.js.map